(function () {
  'use strict';

  angular
    .module('dashboard.interval')
    .factory('DashboardInterval', DashboardInterval);

  DashboardInterval.$inject = ['$resource'];

  function DashboardInterval($resource) {
    return $resource(
      '/api/',
      {},
      {
        day: { method: 'GET', url: '/api/dashboard/statistic/:from' },
        week: { method: 'GET', url: '/api/dashboard/statistic/:from/:to' },
        month: { method: 'GET', url: '/api/dashboard/statistic/:from' },
        year: { method: 'GET', url: '/api/dashboard/statistic/:from' },
      },
    );
  }
})();
